export default {
  CREATE_NEW_NOTE: 'create_new_note',
};



// WEBPACK FOOTER //
// ./src/constants/logEvents.js